import React, { useContext, useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";

import styles from "./Challenges.module.scss";

import AppContext from "context/AppContext";

import CardChallenge from "shared/components/CardChallenge/CardChallenge";
import Button from "shared/components/Buttons/Button";
import AddChallengeModal from "./AddChallengeModal/AddChallengeModal";
import CardChallengeSkeleton from "shared/components/CardChallenge/CardChallengeSkeleton/CardChallengeSkeleton";

import { ReducerTypes } from "shared/types/reducerTypes";
import apiCalls from "shared/utils/apiCalls";
import Dropdown from "shared/components/Dropdown/Dropdown";

import { intersection } from "lodash";

const Challenges = ({
  pathDropdown,
  challengeDropdown,
  levelDropdown,
}: any) => {
  const { state, dispatch } = useContext(AppContext);
  const [challengeModalOpen, setChallengeModalOpen] = useState<boolean>(false);

  const getNotifications = async () => {
    const res = await apiCalls({
      method: "get",
      url: `/notifications`,
    });

    if (res) {
      dispatch({
        type: ReducerTypes.getNotification,
        payload: { value: res.data },
      });
    }
  };

  useEffect(() => {
    getNotifications();

    // eslint-disable-next-line
  }, []);

  const isChallengeCompleted = (id: string) => {
    return (
      state.userSolutions?.filter(
        ({ challengeId }: { challengeId: string }) => challengeId === id
      ).length > 0
    );
  };

  const filterByChallenge = (challenges: any) => {
    if (
      challengeDropdown.selectedOptionValues.includes("completed") &&
      challengeDropdown.selectedOptionValues.includes("not-completed")
    ) {
      return challenges;
    }

    if (challengeDropdown.selectedOptionValues.includes("completed")) {
      return challenges.filter(({ id }: any) => isChallengeCompleted(id));
    }

    if (challengeDropdown.selectedOptionValues.includes("not-completed")) {
      return challenges.filter(({ id }: any) => !isChallengeCompleted(id));
    }
    return challenges;
  };

  const filterByPath = (challenges: any) => {
    if (pathDropdown.selectedOptionValues.length <= 0) {
      return challenges;
    }
    return challenges.filter(({ tags }: any) => {
      return intersection(tags, pathDropdown.selectedOptionValues).length > 0;
    });
  };

  const filterByLevels = (challenges: any) => {
    if (levelDropdown.selectedOptionValues.length <= 0) {
      return challenges;
    }

    return challenges.filter(({ level }: any) => {
      return levelDropdown.selectedOptionValues.includes(parseInt(level));
    });
  };

  const getFilteredChallenges = (challenges: any) => {
    return filterByLevels(filterByPath(filterByChallenge(challenges)));
  };

  const onChallengeDropdownSelect = (option: any) => {
    challengeDropdown.onSelected(option);
  };

  const onPathDropdownSelect = (option: any) => {
    pathDropdown.onSelected(option);
  };

  const onLevelDropdownSelect = (option: any) => {
    levelDropdown.onSelected(option);
  };

  return (
    <>
      <div className={styles.challenges}>
        {state.user && state.user.role === "admin" && (
          <AddChallengeModal
            open={challengeModalOpen}
            closeModal={() => setChallengeModalOpen(false)}
          />
        )}

        <div className={styles.challenges_heading}>
          <h1>Challenges</h1>

          {state.user && state.user.role === "admin" && (
            <Button
              aria-label="add challenge"
              buttonVariant="secondary"
              onClick={() => setChallengeModalOpen(true)}
            >
              Add Challenge
            </Button>
          )}
        </div>

        <Grid
          container
          direction="row"
          spacing={3}
          style={{ marginBottom: "var(--space-xs)" }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <Dropdown
              label="challenges"
              selectedValue={challengeDropdown.selectedOptions}
              onSelected={onChallengeDropdownSelect}
              options={challengeDropdown.optionsWithSelectedItems}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Dropdown
              label="paths"
              selectedValue={pathDropdown.selectedOptions}
              onSelected={onPathDropdownSelect}
              options={pathDropdown.optionsWithSelectedItems}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Dropdown
              label="levels"
              selectedValue={levelDropdown.selectedOptions}
              onSelected={onLevelDropdownSelect}
              options={levelDropdown.optionsWithSelectedItems}
            />
          </Grid>
        </Grid>

        {state.challenges &&
          getFilteredChallenges(state.challenges).length <= 0 && (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                minHeight: "100px",
                marginTop: "var(--space-3xl)",
                fontFamily: "var(--heading-font-family)",
                fontSize: "var(--text-lg)",
                fontWeight: 700,
                color: "var(--grey-3)",
              }}
            >
              No Challenges Found
            </div>
          )}

        {state.challenges ? (
          <Grid container direction="row" spacing={3}>
            {getFilteredChallenges(state.challenges).map((challenge: any) => (
              <Grid item xs={12} md={6} lg={4} key={challenge.id}>
                <CardChallenge
                  completed={isChallengeCompleted(challenge.id)}
                  challenge={challenge}
                  to={`/challenges/${challenge.id}`}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container direction="row" spacing={3}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((number: number) => (
              <Grid item xs={12} md={6} lg={4} key={number}>
                <CardChallengeSkeleton />
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    </>
  );
};

export default Challenges;
